$(document).on('click', '.toggle-password', function () {
    var $this = $(this);
    var $input = $this.siblings('input');
    if ($input.attr('type') === 'password') {
        $input.attr('type', 'text');
        $this.removeClass('fa-eye').addClass('fa-eye-slash');
    } else {
        $input.attr('type', 'password');
        $this.removeClass('fa-eye-slash').addClass('fa-eye');
    }
});

function getDateFormat() {
    return moment.localeData().longDateFormat('L');
}

function initDateMask(container) {
    $(container || document).find('.date-input').each(function () {
        var el = this;
        if ($(el).data('imask')) return;
        var fmt = getDateFormat();
        $(el).attr('placeholder', fmt);

        var mask = IMask(el, {
            mask: Date,
            pattern: fmt,
            format: function (date) {
                return moment(date).format(fmt);
            },
            parse: function (str) {
                return moment(str, fmt).toDate();
            },
            blocks: {
                DD: { mask: IMask.MaskedRange, from: 1, to: 31, maxLength: 2, placeholderChar: 'D', autofix: 'pad' },
                MM: { mask: IMask.MaskedRange, from: 1, to: 12, maxLength: 2, placeholderChar: 'M', autofix: 'pad' },
                YYYY: { mask: IMask.MaskedRange, from: 1900, to: new Date().getFullYear() - 18, maxLength: 4, placeholderChar: 'Y' }
            },
            min: new Date(1900, 0, 1),
            max: new Date(new Date().getFullYear() - 18, 11, 31),
            lazy: false,
            eager: true,
            overwrite: true
        });
        $(el).data('imask', mask);
    });
}

function getDateISO(element) {
    var mask = $(element).data('imask');
    if (mask && mask.masked.isComplete) {
        return moment(mask.typedValue).format('YYYY-MM-DD');
    }
    var value = element.value;
    var m = moment(value, getDateFormat(), true);
    return m.isValid() ? m.format('YYYY-MM-DD') : '';
}

function setDateFromISO(selector, isoDate) {
    var $input = $(selector || '#birthday');
    var fmt = getDateFormat();
    var m = moment(isoDate);
    if (m.isValid()) {
        $input.val(m.format(fmt));
        var mask = $input.data('imask');
        if (mask) { mask.updateValue(); }
    }
}

$(function () { initDateMask(); });

function fillData(data) {

    $('[data-field]:not(select,input)').each(function(){

        var $this = $(this);
        var fieldname = $this.attr('data-field');
        var val = '';

        var datakey = fieldname === 'homelogo' ? 'homeevent' : fieldname;

        if (typeof(data[datakey]) == 'undefined' || data[datakey] == null) {
            return;
        }

        var dataval = data[datakey];

        if (fieldname === 'gender' || fieldname === 'status') {

            val = capitalizeFirstLetter(dataval);

            if(dataval === 'male') { val = _male; }
            if(dataval === 'female') { val = _female; }
            if(dataval === 'other') { val = _other; }
            if(dataval === 'unknown') { val = _unknown; }
            if(dataval === 'silver') { val = _silver; }
            if(dataval === 'gold') { val = _gold; }
            if(dataval === 'platinum') { val = _platinum; }

            $this.html(val);
            return;
        }
        if (fieldname === 'birthday' || fieldname === 'created_at') {

            val = moment(dataval).format('MMMM Do, YYYY');

            $this.html(val);
            return;
        }
        if (fieldname === 'registrations' || fieldname === 'subscriptions') {
            $this.html(dataval.length);
            return;
        }
        if (fieldname === 'id') {
            $this.html(dataval);
            return;
        }
        if (fieldname === 'country') {
            $this.html(typeof(countries[dataval]) == 'undefined' ? dataval : countries[dataval]);
            return;
        }
        if (fieldname === 'homeevent') {
            getEventJSON()
                .done(function(data) {
                    var event = _.find(data, function(o) { return o.passport.subscription_code === dataval; });
                    if (event) {
                        $this.html(event.title_label);
                    }
                });
            return;
        }
        if (fieldname === 'homelogo') {
            getEventJSON()
                .done(function(data) {
                    var event = _.find(data, function(o) { return o.passport.subscription_code === dataval; });
                    if (event && event.media.white_logo) {
                        var logo = `<img alt="${event.title}" src="${event.media.white_logo}" class="homelogo" width="175">`;
                    } else {
                        var logo = event.title_label;
                    }
                    if (event && event.url) {
                        var website = event.url;
                    } else {
                        var website = '#';
                    }
                    $this.html(`<a href="${website}" target="_blank">${logo}</a>`);
                });
            return;
        }
        if (fieldname === 'points') {
            $this.attr('data-points', dataval);
            val = Number(dataval).toLocaleString();
            $this.html(val);
            fillProgress(dataval);
            return;
        }

        if (fieldname === 'level_expires') {
            var val = moment(dataval).format('MMM Do, YYYY');
            $('[data-field="level_expires"]').text(val);
            if ( data.level !== 0 ) {
                $('.expires-note').fadeIn(300);
            }
            return;
        }

        if (fieldname === 'level_code') {
            fillStatus(dataval);
            return;
        }

        $this.html($.parseHTML(dataval));

        if (!! _dashboard.length) {
            _dashboard.fadeTo(300,1);
        }

    });
}

var fillStatusRan = false;
function fillStatus(level = 'silver') {
    if ( fillStatusRan ) {
        return;
    }

    let level_assets = upp_assets.images.levels[level];

    $('.uplevel[data-field="level_code"]').html(level).addClass(level);
    $('[data-field="gfx"]').html(`<img alt="${level} icon" src="${level_assets.gfx}">`);
    $('[data-field="icon"]').html(`<img alt="${level} icon" src="${level_assets.icon}">`);
    $('[data-field="stamp"]').html(`<img alt="${level} icon" src="${level_assets.stamp}" width="95">`);
    fillStatusRan = true;
}


var fillProgressRan = false;
function fillProgress(points) {

    if ( fillProgressRan ) {
        return;
    }

    if (points >= uppplatinum) {
        level = 'platinum';
    } else if (points >= uppgold) {
        level = 'gold';
    } else {
        level = 'silver';
    }

    neededpoints = uppgold - points;
    nextpercent = (points / uppgold).toFixed(2) * 100;

    if(level === 'gold') {
        levelnextname = 'platinum';
        levelpointsstart = uppgold;
        neededpoints = uppplatinum - points;
        levelpointsend = uppplatinum;
        nextpercent = (points / uppplatinum).toFixed(2) * 100;
    }
    if(level === 'platinum') {
        levelnextname = 'platinum';
        levelpointsstart = uppplatinum;
        neededpoints = 0;
        levelpointsend = uppplatinum;
        nextpercent = 100;
    }

    levelpointsstart = Number(levelpointsstart).toLocaleString();
    levelpointsend = Number(levelpointsend).toLocaleString();
    neededpoints = Number(neededpoints).toLocaleString();

    $('[data-field="level-current-name"]').html(level).addClass(level);
    $('[data-field="level-next-name"]').html(levelnextname).addClass(levelnextname);
    $('[data-field="level-points-start"]').html(levelpointsstart).addClass(level);
    $('[data-field="level-points-end"]').html(levelpointsend).addClass(levelnextname);
    $('[data-field="level-next-points"]').html(neededpoints);
    $('[data-field="level-next-percent"]').html(nextpercent);
    $('[data-field="fillpercent"]').css({'width':nextpercent+'%'});

    $('span.next-status').html(levelnextname).addClass(levelnextname);
    $('div.level').removeClass('silver gold platinum');
    $('div.level').addClass(level);


    if (level === 'platinum') {
        $('.unlock-note').html("<span class='platinum'>Platinum</span> Level Reached!");
        $('.unlock-note').html("<strong>Max Level Reached!</strong>");
        //$('[data-field="level-points-end"]').html('?');
        //$('[data-field="level-next-name"]').html('?');
        $('[data-field="level-points-start"]').html(Number(uppgold).toLocaleString()).removeClass('platinum').addClass('gold');
        $('[data-field="level-current-name"]').html('gold').removeClass('platinum').addClass('gold');
    }

    fillProgressRan = true;
}

function hideResult() {
    notyf.dismissAll();
}

function showResult(content, type = 'info', options = {}) {
    return notyf.open({
        type: type,
        message: content,
        ...options
    });
}

function scrollToTop() {
    return new Promise((resolve, reject) => {
        $("html:not(:animated), body:not(:animated)").animate({
            scrollTop: 0
        }, {
            duration: 900,
            easing: 'easeInOutExpo',
            complete: resolve // This will be called once the animation is complete.
        });
    });
}



function modalClose(modalContainer) {
    var modalContainer = $(modalContainer) || $('.modal');
    modalContainer.on('click', '.md-close', function (e) {
        var $this = $(this);
        e.preventDefault();
        $this.parent().fadeOut(300);
        modalClosed();
    });
    $(document).on("keyup", function (event) {
        if (event.keyCode === 27 && !!modalContainer.find('.md-close').length) {
            modalContainer.find('.md-close').trigger('click');
            modalClosed();
        }
    });
}

function modalOpen() {
   //hideResult('modal');
   $('html').addClass('modalopen');
}

function modalClosed() {
    hideResult()
    $('html').removeClass('modalopen');
}

function registrationNotice(passport) {
    //log(passport.registrations.length);
    if(!passport.registrations.length && passport.status === 'active') {
        //showResult(_globalnotice, 'info');
    }

    if(passport.registrations.length && passport.status === 'active') {
        //showResult(_globalnoticereg, 'info');
    }
}


/*
function combineDates() {

    var birthday = $('#birthday');
    var datefields = $('#bday_month, #bday_day, #bday_year');

    if ( !! birthday.length ) {

        var updateDate = function() {

          var month = $('#bday_month').val();
          var day = $('#bday_day').val();
          var year = $('#bday_year').val();

          var singular_date = year+'-'+month+'-'+day;

          birthday.val(singular_date);

        }

        updateDate();

        datefields.change(function(e) {
          updateDate();
        });

    }

}
*/

function titleCase(str) {
    return str
        .split('-')
        .map(i => i.charAt(0).toUpperCase() + i.slice(1).toLowerCase())
        .join(' ');
}

function capitalizeFirstLetter(string) {
    if (typeof string !== 'string' || string.length === 0) {
        return string;
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function validate() {

    if (!!$('.validate').length) {
        $('.validate').validate();
    }

    $.validator.addClassRules({
        password: {
            minlength: 8,
            maxlength: 100
        }
    });

}


function passwordField() {
    var pwd = document.getElementById("password");

    function hide() {
        pwd.setAttribute('type', 'password');
    }

    function show() {
        pwd.setAttribute('type', 'text');
    }

    pwd.addEventListener("blur", function () {
        hide();
    }, false);

    pwd.addEventListener("focus", function () {
        show();
    }, false);
}

function convertToSlug(Text) {
    return Text
    .toLowerCase()
    .replace(/[^\w ]+/g,'')
    .replace(/ +/g,'-')
    ;
}

// Scroll to top function
jQuery(function($) {
    $.fn.scrollToTop = function() {
        $(this).on('click', function() {
            $("html, body").animate({
                scrollTop: 0
            }, {duration:900, easing:'easeInOutExpo'})
        })
    }
});

function fillParams() {
    var token = getUrlParam('token');
    var email = getUrlParam('email');
    if(!email) {
        email = getUrlParam('verifyemail');
    }
    var home = getUrlParam('home');
    if ( email ) {
        $('#updateemail').val(email);
        $('#loginemail').val(email);
        $('#email').val(email);
        $('#verifyemail').val(email);
    }
    if ( token ) { $('#token').val(token); }
    if ( home ) { $('#homeevent').val(home); }
}

function getUrlParam(param, returnArray){
    var current_url = new URL(window.location);

    if (returnArray) {
        return current_url.searchParams.getAll(param);
    }
    return current_url.searchParams.get(param);
}

function passportRedirect(fallback_url){
    var redirect;
    var url_redirect = getUrlParam('redirect');

    if(url_redirect){
        redirect = url_redirect;
    }
    else if(fallback_url) {
        redirect = fallback_url;
    }
    else {
        redirect = upp_page.dashboard;
    }
    window.location.assign(redirect);
}

/**
 * Generic array sorting
 *
 * @param property
 * @returns {Function}
 */
 var sortByProperty = function (property) {
     return function (x, y) {
         return ((x[property] === y[property]) ? 0 : ((x[property] > y[property]) ? 1 : -1));
     };
 };

 function getCFCountry() {
     return $.get('/cdn-cgi/trace').then(function (data) {
         var match = data.match(/loc=(\w+)/);
         return match ? match[1] : null;
     }).catch(function () {
         return null;
     });
 }

 function mergeRecursive (obj1, obj2) {
     return _.mergeWith({}, obj1, obj2, function(objValue, srcValue) {
         if (_.isArray(objValue)) {
             return objValue.concat(srcValue);
         }
     })
 }

// Custom validator: birthday mask must be fully completed
$.validator.addMethod('completeDate', function(value, element) {
    var mask = $(element).data('imask');
    if (mask) { return mask.masked.isComplete; }
    return value.length > 0;
}, 'This field is required.');